import { lazy } from "react";
import { Navigate, Route } from "react-router";

const SocialPostsPage = lazy(() =>
  import("../features/growth/social-posts/SocialPostsPage").then((m) => ({
    default: m.SocialPostsPage,
  })),
);
const ShortLinksPage = lazy(() =>
  import("../features/growth/short-links/ShortLinksPage").then((m) => ({
    default: m.ShortLinksPage,
  })),
);
const NotificationHistoryPage = lazy(() =>
  import("../features/notifications/NotificationHistoryPage").then((m) => ({
    default: m.NotificationHistoryPage,
  })),
);
const SiteFormsPage = lazy(() =>
  import("../features/growth/site-forms/SiteFormsPage").then((m) => ({
    default: m.SiteFormsPage,
  })),
);
const WidgetConfiguratorPage = lazy(() =>
  import("../features/growth/widget-configurator/WidgetConfiguratorPage").then((m) => ({
    default: m.WidgetConfiguratorPage,
  })),
);

// Route order inside <Route path="/w/:workspaceId"> is preserved: this fragment slots in where it was inline.
export const workspaceMiscRoutes = (
  <>
    <Route path="notifications" element={<NotificationHistoryPage />} />
    {/* OWN-317: the Manager Console moved into the assistant panel */}
    <Route
      path="console"
      element={<Navigate to={{ pathname: "..", search: "?assistant=1" }} relative="path" replace />}
    />
    <Route path="growth/widget" element={<WidgetConfiguratorPage />} />
    <Route path="growth/site-forms" element={<SiteFormsPage />} />
    <Route path="growth/short-links" element={<ShortLinksPage />} />
    <Route path="growth/social-posts" element={<SocialPostsPage />} />
  </>
);
